export default "__VITE_ASSET__CLEWLcWQ__"